/**
 * 用来做滚动翻页, 放在滚动列表下方即可
 */
import React, { useCallback, useEffect, useRef } from "react";

interface LoadMoreProps {
    onVisible: () => void;
    className?: string;
    hasMore: boolean;
    tip?: string;
}

export default function LoadMore({
    hasMore,
    onVisible,
    className,
    tip
}: LoadMoreProps) {
    const eventRef = useRef(onVisible);
    const ref = useRef<HTMLDivElement>(null);

    eventRef.current = onVisible;

    const onScroll = useCallback(() => {
        if (!ref.current) return;
        if (!isInViewport(ref.current)) return;
        eventRef.current();
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    function isInViewport(element: HTMLDivElement) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    if (!hasMore) return null;

    return (
        <div style={{ textAlign: "center" }} className={className} ref={ref}>
            {tip || "正在加载更多..."}
        </div>
    );
}
